import { MembershipProfileTag } from '@models/membership/MembershipProfileTag'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_PROFILE_TAGS_URL } from '@utils/urls'

const fetchMembershipProfileTags = (params: TableParams) =>
  SBAPI.FetchPaginated<MembershipProfileTag[]>(
    MEMBERSHIP_PROFILE_TAGS_URL,
    params
  )

const fetchMembershipProfileTagById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<MembershipProfileTag>(
    `${MEMBERSHIP_PROFILE_TAGS_URL}/${id}`,
    params
  )

const createMembershipProfileTag = (tag: MembershipProfileTag) =>
  SBAPI.Post(MEMBERSHIP_PROFILE_TAGS_URL, tag)

const updateMembershipProfileTag = (tag: MembershipProfileTag) =>
  SBAPI.Put(`${MEMBERSHIP_PROFILE_TAGS_URL}/${tag.id}`, tag)

const deleteMembershipProfileTag = (tag: MembershipProfileTag) =>
  SBAPI.Delete(`${MEMBERSHIP_PROFILE_TAGS_URL}/${tag.id}`)

export {
  createMembershipProfileTag,
  deleteMembershipProfileTag,
  fetchMembershipProfileTagById,
  fetchMembershipProfileTags,
  updateMembershipProfileTag,
}
